module.exports = __webpack_public_path__ + "static/media/outfit7.0dae486a.jpg";